import {Component} from '@angular/core';
import {ILoadingOverlayAngularComp} from 'ag-grid-angular';
import {ILoadingOverlayParams} from 'ag-grid-community';
import {DEFAULT_LOADER_INFINITE, ISharedLoadingG} from '../../../shared-module-ui/models/animations';

/**
 * Custom loading overlay component for AG Grid that displays the shared loading indicator.
 */
@Component({
    selector: 'app-shared-grid-loading-overlay',
    templateUrl: './shared-grid-loading-overlay.component.html',
    styleUrls: ['./shared-grid-loading-overlay.component.scss'],
    standalone: false
})
export class SharedGridLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  public params: ILoadingOverlayParams;
  public animation: ISharedLoadingG = DEFAULT_LOADER_INFINITE;

  /**
   * Initialize the loading overlay component with AG Grid parameters.
   * @param params The loading overlay parameters from AG Grid.
   */
  agInit(params: ILoadingOverlayParams): void {
    this.params = params;
  }
}
